// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"370f0e8a","246":"320778c7","285":"09ec07ed","416":"30cd7ccc","436":"78f4b568","883":"699aab63"}[chunkId] + ".chunk.js";
};